<template>
     <div class="MyPagination">


        <ul class="pagination">
            <li
                :class="isFirst()
                    ? 'disabled'
                    : ''"
                v-if="hasPages()"
            >
                <a href @click.prevent="prev()" >
                    <i class="material-icons">chevron_left</i>
                </a>
            </li>

            <li>
                <a @click.prevent="goPage(1)" href>Primeiro</a>
            </li>
            <li
                v-for="index in links"
                :key="index"
                :class="isCurrent(index) ? 'active' : ''">
                <a href @click.prevent="goPage(index)">
                    {{index}}
                </a>
            </li>

            <li>
                <a href @click.prevent="goPage(pages)">Último</a>
            </li>

            <li
                class=""
                :class="isLast() ? 'disabled' : ''"
                v-if="hasPages()"
                @click="next()"
            >
                <a href>
                    <i class="material-icons">chevron_right</i>
                </a>
            </li>
        </ul>
    </div>

</template>

<style lang="scss">
    @import './Pagination.scss';
</style>

<script>
export default {
    data () {
        return {
            pages  : 0,
            current: 1,
            back   : false,
        };
    },
    updated() {
        this.updateAll();
    },

    created() {
        this.updateAll();
    },
    computed: {

        totalPages() {
            return Math.ceil(this.qty / this.perPage);
        },

        links () {
            const links = [];

            // const start = Math.floor(this.current / this.limit) * this.limit;

            const start = Math.max(0, this.current - this.limit + 1);
            const end = Math.min(this.totalPages, start + this.limit);

            for (let i = start; i < end; i++) {
                links.push(i + 1);
            }

            return links;
        }
    },
    props: {
       perPage: {
            type: [Number, String],
            default: 1,
            required: true,
       },
       qty: {
            type    : Number,
            default : 1,
            required: true,
       },
       setCurrent: {
            type     : Function,
            required : true
       },

       limit: {
           type: Number,
           default: 5,
       }
    },
    watch:{
        perPage(){
            this.updateAll();
        },
        qty(){
            this.updateAll();
        },
    },
    methods: {
        calcShow(page){

            const limit = 10;
            const start = Math.floor(this.current / limit) * limit;
            const end   = start + limit;

            return page >= start && page <= end;
        },
        updateAll(){
            this.pages = this.calcPages();
            // this.limit = this.pages > this.limit ? this.limit : this.pages;
        },
        calcPages(){
            return Math.ceil( this.qty / this.perPage);
        },
        hasPages(){
            return this.pages > 1;
        },
        isFirst(){
            return this.current == 1;
        },
        isLast(){
            return this.current == this.pages;
        },
        isCurrent(i){
            return this.current == i;
        },
        next(){
            if(this.current + 1 <= this.pages){
                this.current += 1;
                this.setCurrent(this.current);
                this.back = false;
                 document.querySelector('#header').scrollIntoView();
            }
        },
        prev(){
            if(this.current - 1 > 0){
                this.current -= 1;
                this.setCurrent(this.current);
                this.back = true;
                document.querySelector('#header').scrollIntoView();
            }
        },
        goPage(page){
            this.current = page;
            this.setCurrent(this.current);
             document.querySelector('#header').scrollIntoView();
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/common/Pagination/Pagination.vue